import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';
import {
    SftpAuthenticationType,
    sftpAuthenticationLabelKeys,
} from '../../../sftp-connections/sftp-connection.model';
import {BadgePillComponent} from '../badge-pill/badge-pill.component';

const colorClasses: Record<SftpAuthenticationType, string> = {
    SSH_KEY: 'text-primary',
    PASSWORD: 'text-success',
};

@Component({
    selector: 'app-sftp-authentication-badge',
    standalone: true,
    imports: [BadgePillComponent, TranslatePipe],
    template: `
        <app-badge-pill
            [label]="labelKey() | translate: 'online' : 'export'"
            [colorClass]="colorClass()" />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SftpAuthenticationBadgeComponent {
    readonly authenticationType = input.required<SftpAuthenticationType>();

    protected readonly labelKey = computed(
        () => sftpAuthenticationLabelKeys[this.authenticationType()],
    );
    protected readonly colorClass = computed(() => colorClasses[this.authenticationType()]);
}
